






























































































































































































































































































































import Vue from 'vue'
import api from '../../../../api'
import KkiapayVerificationModal from '../../components/KkiapayVerificationModal.vue'
import CreditReimbursementsModal from '../../components/CreditReimbursementsModal.vue'

export default Vue.extend({
  components: {
    KkiapayVerificationModal,
    CreditReimbursementsModal
  },

  data() {
    return {
      loading: false,
      data: null as any,
      showKkiapayModal: false,
      showReimbursementsModal: false,
      selectedCredit: null as any,
      statusFilter: 'all' as string,
      sfdName: '' as string,
      actionLoading: false,
      integrityCheck: null as any,
      columns: [
        { label: 'Bénéficiaire', field: 'beneficiary.name' },
        { label: 'Téléphone', field: 'beneficiary.phone' },
        { label: 'Montant', field: 'amount' },
        { label: 'État', field: 'state' },
        { label: 'Erreur', field: 'error' },
        { label: 'Actions', field: '_actions' }
      ]
    }
  },

  computed: {
    sfdId(): string {
      return this.$route.params.sfdId
    },

    dispatchingId(): string {
      return this.$route.params.dispatchingId
    },

    filteredCredits(): any[] {
      if (!this.data || !this.data.credits) return []
      if (this.statusFilter === 'all') return this.data.credits

      return this.data.credits.filter((credit: any) => {
        if (this.statusFilter === 'pending') {
          return credit.state === 'pending' || credit.state === 'created'
        }
        return credit.state === this.statusFilter
      })
    }
  },

  methods: {
    async loadSfdName() {
      try {
        const cachedName = localStorage.getItem(`sfd_${this.sfdId}_name`)
        if (cachedName) {
          this.sfdName = cachedName
        }
      } catch (error) {
        console.error('Error loading SFD name:', error)
      }
    },

    getStateLabel(state: string): string {
      const labels: Record<string, string> = {
        succeeded: 'Succès',
        failed: 'Échec',
        pending: 'En attente',
        created: 'Créé'
      }
      return labels[state] || state
    },

    getDispatchingStateLabel(state: string): string {
      const labels: Record<string, string> = {
        completed: 'Complété',
        pending: 'En cours',
        created: 'Créé',
        canceled: 'Annulé'
      }
      return labels[state] || state
    },

    formatKkiapayError(credit: any): string {
      if (!credit.kkiapayFailureReason) return '-'

      try {
        const errorData = JSON.parse(credit.kkiapayFailureReason)
        if (errorData.errorReasons && errorData.errorReasons.length > 0) {
          return errorData.errorReasons
            .map((err: any) => err.message)
            .join(', ')
        }
        if (
          errorData.stateData &&
          errorData.stateData.errorReasons &&
          errorData.stateData.errorReasons.length > 0
        ) {
          return errorData.stateData.errorReasons
            .map((err: any) => err.message)
            .join(', ')
        }
        if (errorData.rawhistory && Array.isArray(errorData.rawhistory)) {
          const messages: string[] = []
          errorData.rawhistory.forEach((history: any) => {
            const historyData =
              typeof history === 'string' ? JSON.parse(history) : history
            if (historyData.response && historyData.response.body) {
              if (historyData.response.body.message) {
                messages.push(historyData.response.body.message)
              }
              if (historyData.response.body.description) {
                messages.push(historyData.response.body.description)
              }
            }
          })
          if (messages.length > 0) return messages.join(' | ')
        }
        return 'Erreur de transaction'
      } catch (e) {
        return credit.kkiapayFailureReason.substring(0, 100)
      }
    },

    async completeDispatching() {
      if (
        !confirm(
          "Êtes-vous sûr de vouloir passer ce dispatching à l'état Complété ?"
        )
      )
        return

      this.actionLoading = true
      try {
        await api.post(`/dispatchings/${this.dispatchingId}/complete`)
        this.$notify.success('Dispatching passé à Complété')
        await this.loadCredits()
      } catch (error) {
        console.error('Error completing dispatching:', error)
        this.$notify.error('Erreur lors du passage à Complété')
      } finally {
        this.actionLoading = false
      }
    },

    async retryFailedCredits() {
      if (
        !confirm(
          `Êtes-vous sûr de vouloir relancer les ${this.data.stats.failed} crédits échoués ?`
        )
      )
        return

      this.actionLoading = true
      try {
        await api.post(
          `/dispatchings/${this.dispatchingId}/retry-failed-credits`
        )
        this.$notify.success('Relance des crédits échoués lancée')
        await this.loadCredits()
      } catch (error) {
        console.error('Error retrying failed credits:', error)
        this.$notify.error('Erreur lors de la relance des crédits échoués')
      } finally {
        this.actionLoading = false
      }
    },

    async checkIntegrity() {
      this.actionLoading = true
      try {
        const response = await api.get(
          `/dispatchings/${this.dispatchingId}/check-missing-credits`
        )
        this.integrityCheck = response.data
        if (this.integrityCheck.missingCredits === 0) {
          this.$notify.success('Aucun crédit manquant détecté')
        } else {
          this.$notify.warning(
            `${this.integrityCheck.missingCredits} crédit(s) manquant(s) détecté(s)`
          )
        }
      } catch (error) {
        console.error('Error checking integrity:', error)
        this.$notify.error("Erreur lors de la vérification de l'intégrité")
      } finally {
        this.actionLoading = false
      }
    },

    async fixIntegrity() {
      if (
        !confirm(
          `Êtes-vous sûr de vouloir corriger l'intégrité (créer ${this.integrityCheck.missingCredits} crédits manquants) ?`
        )
      )
        return

      this.actionLoading = true
      try {
        await api.post(
          `/dispatchings/${this.dispatchingId}/create-missing-credits`
        )
        this.$notify.success('Crédits manquants créés avec succès')
        this.integrityCheck = null
        await this.loadCredits()
      } catch (error) {
        console.error('Error fixing integrity:', error)
        this.$notify.error("Erreur lors de la correction de l'intégrité")
      } finally {
        this.actionLoading = false
      }
    },

    async loadCredits() {
      this.loading = true
      try {
        const response = await api.get(
          `/dispatching-credits/dispatching/${this.dispatchingId}/detailed`
        )
        this.data = response.data
      } catch (error) {
        console.error('Error loading credits:', error)
        this.$notify.error('Erreur lors du chargement des crédits')
      } finally {
        this.loading = false
      }
    },

    verifyTransaction(credit: any) {
      this.selectedCredit = credit
      this.showKkiapayModal = true
    },

    viewReimbursements(credit: any) {
      this.selectedCredit = credit
      this.showReimbursementsModal = true
    }
  },

  async created() {
    await this.loadSfdName()
    await this.loadCredits()
  }
})
